var _g, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMessenger = function SvgMessenger(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_588_1006)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34835 17.1803H12.2986C12.7122 17.6419 13.2077 18.1731 13.6694 18.6951C14.7147 19.8773 16.5401 20.2929 16.8963 20.3871C17.2525 20.4812 18.829 20.9899 18.2577 20.3266C17.6865 19.6634 17.1173 17.9602 17.1173 17.1792H18.7583C20.2735 17.1792 21.5154 15.9448 21.5154 14.4332V5.6318C21.5154 4.1221 20.2736 2.88867 18.7583 2.88867H5.34736C3.83017 2.88867 2.58743 4.12304 2.58743 5.6318V14.4332C2.58743 15.9449 3.82923 17.1792 5.34736 17.1792L5.34835 17.1803Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3529 15.1092C12.5259 15.1092 11.8531 14.4346 11.8531 13.6055V12.6203H10.043C9.21596 12.6203 8.54321 11.9456 8.54321 11.1165C8.54321 10.2874 9.21608 9.61279 10.043 9.61279H11.8531V7.64224H10.8705C10.0435 7.64224 9.37072 6.9676 9.37072 6.1385C9.37072 5.30941 10.0436 4.63477 10.8705 4.63477C11.6974 4.63477 12.3703 5.30941 12.3703 6.1385V7.12372H14.1804C15.0075 7.12372 15.6802 7.79836 15.6802 8.62746C15.6802 9.45655 15.0073 10.1312 14.1804 10.1312H12.3703V12.1017H13.3529C14.18 12.1017 14.8527 12.7764 14.8527 13.6055C14.8527 14.4346 14.1798 15.1092 13.3529 15.1092ZM12.3703 12.6201V13.6054C12.3703 14.1486 12.8111 14.5906 13.3529 14.5906C13.8948 14.5906 14.3355 14.1486 14.3355 13.6054C14.3355 13.0621 13.8948 12.6201 13.3529 12.6201H12.3703ZM10.043 10.1311C9.50116 10.1311 9.06038 10.573 9.06038 11.1163C9.06038 11.6596 9.50116 12.1015 10.043 12.1015H11.8531V10.131H10.043V10.1311ZM12.3703 9.61255H14.1804C14.7223 9.61255 15.1631 9.1706 15.1631 8.62734C15.1631 8.08407 14.7223 7.64212 14.1804 7.64212H12.3703V9.61267V9.61255ZM10.8704 5.15306C10.3286 5.15306 9.88777 5.595 9.88777 6.13827C9.88777 6.68153 10.3286 7.12348 10.8704 7.12348H11.853V6.13827C11.853 5.595 11.4122 5.15306 10.8704 5.15306Z",
    fill: "#00BB99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_588_1006",
    x: 0.328207,
    y: 0.834858,
    width: 23.4464,
    height: 22.2918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.205381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1296
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_1006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_1006",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.02691,
    dy: -1.33498
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.05381
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.945098 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_588_1006"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.718835,
    dy: -0.718835
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.256727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_588_1006",
    result: "effect3_innerShadow_588_1006"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.513453,
    dy: -1.33498
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28363
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.839216 0 0 0 0 0.760784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_588_1006",
    result: "effect4_innerShadow_588_1006"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messenger.f51fbde3.svg";
export { ForwardRef as ReactComponent };